<template>
  <div class="User-Modal" :class="{ 'User-Modal--backdrop-static': !closeOnBackdrop }">
    <b-modal :id="id" hide-footer centered hide-header v-model="temp_value" ref="Modal" :backdrop="closeOnBackdrop ? true : 'static'"
      @hide="handleHide"  >
      <div class="Modal-Nav">
        <div class="Modal-Title"><slot name="Title"></slot></div>
        <div class="Modal-Content"><slot name="Content"></slot></div>
        <div class="Modal-Footer">
          <div class="Modal-Footer-Left">
              <slot name="leftFooter"></slot>
          </div>
          <div class="Modal-Footer-RightBody">
            <div class="Modal-Footer-Middle">
              <slot name="MiddleFooter"></slot>
            </div>
            <div class="Modal-Footer-Right">
              <slot name="RightFooter"></slot>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    id:
    {
      type: String,
      default: ''
    },
    value:
    {
      type: Boolean,
      default: false
    },
    closeOnBackdrop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      temp_value: this.value,
      originalBackdropZIndex: null,
      originalSidebarZIndex: null,
      originalDialogSidebarZIndex: null,
      originalSidebarOuterZIndex: null
    }
  },
  watch: {
    value(newVal) {
      this.temp_value = newVal;
      if (newVal) {
        this.lowerUserSettingDialogBackdrop();
      } else {
        this.restoreUserSettingDialogBackdrop();
      }
    },
    temp_value(newVal) {
      this.$emit('input', newVal)
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.temp_value) {
        this.lowerUserSettingDialogBackdrop();
      }
    });
  },
  beforeDestroy() {
    this.restoreUserSettingDialogBackdrop();
  },
  methods:
  {
    handleHide(bvEvent) {
      if (!this.closeOnBackdrop && bvEvent.trigger === 'backdrop') {
        bvEvent.preventDefault();
      }
    },
    lowerUserSettingDialogBackdrop() {
      const userSettingBackdrop = document.querySelector('.User-Dialog .b-sidebar-backdrop');
      if (userSettingBackdrop) {
        if (!this.originalBackdropZIndex) {
          this.originalBackdropZIndex = userSettingBackdrop.style.zIndex || window.getComputedStyle(userSettingBackdrop).zIndex || '100';
        }
        userSettingBackdrop.style.setProperty('z-index', '50', 'important');
      }
      
      const userSettingSidebar = document.querySelector('.user-setting-sidebar');
      if (userSettingSidebar) {
        if (!this.originalSidebarZIndex) {
          const computedZIndex = window.getComputedStyle(userSettingSidebar).zIndex;
          this.originalSidebarZIndex = computedZIndex || '1050';
        }
        userSettingSidebar.style.setProperty('z-index', '1040', 'important');
      }
      
      const userDialogSidebars = document.querySelectorAll('.User-Dialog .b-sidebar');
      userDialogSidebars.forEach((sidebar) => {
        if (!this.originalDialogSidebarZIndex) {
          this.originalDialogSidebarZIndex = window.getComputedStyle(sidebar).zIndex || '1050';
        }
        sidebar.style.setProperty('z-index', '1040', 'important');
      });
      
      const sidebarOuters = document.querySelectorAll('.b-sidebar-outer');
      sidebarOuters.forEach((outer) => {
        const computedZIndex = window.getComputedStyle(outer).zIndex;
        if (computedZIndex && parseInt(computedZIndex) >= 1040) {
          if (!this.originalSidebarOuterZIndex) {
            this.originalSidebarOuterZIndex = computedZIndex;
          }
          outer.style.setProperty('z-index', '1030', 'important');
        }
      });
    },
    restoreUserSettingDialogBackdrop() {
      const userSettingBackdrop = document.querySelector('.User-Dialog .b-sidebar-backdrop');
      if (userSettingBackdrop && this.originalBackdropZIndex) {
        userSettingBackdrop.style.setProperty('z-index', this.originalBackdropZIndex, 'important');
        this.originalBackdropZIndex = null;
      }
      
      const userSettingSidebar = document.querySelector('.user-setting-sidebar');
      if (userSettingSidebar && this.originalSidebarZIndex) {
        userSettingSidebar.style.setProperty('z-index', this.originalSidebarZIndex, 'important');
        this.originalSidebarZIndex = null;
      }
      
      const userDialogSidebars = document.querySelectorAll('.User-Dialog .b-sidebar');
      if (this.originalDialogSidebarZIndex) {
        userDialogSidebars.forEach((sidebar) => {
          sidebar.style.setProperty('z-index', this.originalDialogSidebarZIndex, 'important');
        });
        this.originalDialogSidebarZIndex = null;
      }
      
      if (this.originalSidebarOuterZIndex) {
        const sidebarOuters = document.querySelectorAll('.b-sidebar-outer');
        sidebarOuters.forEach((outer) => {
          outer.style.setProperty('z-index', this.originalSidebarOuterZIndex, 'important');
        });
        this.originalSidebarOuterZIndex = null;
      }
    },
  },
};
</script>
<style scoped>
.Modal-Nav {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  min-height: 0;
  max-height: calc(90vh - 60px);
  overflow-y: hidden;
  overflow-x: visible;
}

.Modal-Title {
  flex-shrink: 0;
}

.Modal-Content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: visible;
  padding-bottom: 8px;
  padding-top: 8px;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
  position: relative;
}

.Modal-Content::-webkit-scrollbar {
  width: 6px;
}

.Modal-Content::-webkit-scrollbar-track {
  background: transparent;
}

.Modal-Content::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.Modal-Footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-shrink: 0;
  background: white;
  position: sticky;
  bottom: 0;
  z-index: 10;
}

.Modal-Footer-RightBody {
  display: flex;
  align-items: center;
  gap: 16px;
}

::v-deep .modal {
  z-index: 2000 !important;
  position: fixed !important;
}

::v-deep .modal-backdrop {
  z-index: 1990 !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
}

/* 仅当禁止点击遮罩关闭（backdrop=static）时使用该半透明黑 */
.User-Modal--backdrop-static ::v-deep .modal-backdrop {
  background: #00000061 !important;
}

::v-deep .modal-dialog {
  z-index: 2001 !important;
  max-width: 500px !important;
  margin: 1.75rem auto !important;
}

::v-deep .modal-content {
  border: none;
  border-radius: 16px !important;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.25);
  max-height: 90vh !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: visible !important;
  position: relative;
  z-index: 2002 !important;
}

::v-deep .modal-body {
  padding: 0 !important;
  overflow: visible !important;
  flex: 1 !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  max-height: calc(90vh - 60px) !important;
}
</style>